import type { FC } from "react";

import { ImageGalleryTopic as ImageGalleryTopicUI } from "@jti/ui/components/ImageGallery";

import type { imageGalleryTopicInputs } from "@/components/ImageGalleryTopic/ImageGalleryTopic.builder";

export type ImageGalleryTopicProps = BuilderComponentProps<typeof imageGalleryTopicInputs>;

export const ImageGalleryTopic: FC<ImageGalleryTopicProps> = ({ data, rtl, mode }) => {
  if (!data) {
    return null;
  }

  const transformedData = {
    ...data,
    topRightImageTablet: data.topRightImageTablet || "",
    topRightImageMobile: data.topRightImageMobile || "",
    bottomLeftImageTablet: data.bottomLeftImageTablet || "",
    bottomLeftImageMobile: data.bottomLeftImageMobile || "",
  };

  return <ImageGalleryTopicUI data={transformedData} rtl={rtl} mode={mode}></ImageGalleryTopicUI>;
};

export default ImageGalleryTopic;
